import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_TotalMode_Switch_Mutation = graphql(`
  mutation MissionServicesInfoForm_TotalMode_Switch(
    $manualTotal: ResolvableServiceValueInput
    $serviceUsagesGroupId: Id!
    $serviceUserId: Id!
    $totalMode: TotalModeEnum!
    $versionData: VersionDataInput
  ) {
    switchMissionTotalMode(
      manualTotal: $manualTotal
      serviceUsagesGroupId: $serviceUsagesGroupId
      serviceUserId: $serviceUserId
      totalMode: $totalMode
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useSwitchMissionTotalModeMutation = () =>
  useGraphQLMutation(MissionServicesInfoForm_TotalMode_Switch_Mutation);
